import React from "react";
import { AdvanceTablesWidget15 } from "../../../_metronic/_partials/widgets/advance-tables/AdvanceTablesWidget15";
export function DeactivatedVideo() {
  return (
    <div className="row">
      <div className="col-lg-12">
        <AdvanceTablesWidget15></AdvanceTablesWidget15>
      </div>
    </div>
  );
}
